import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import * as routes from './routes';
import LoginPage from './components/auth/LoginPage';
import ForgotPasswordPage from './components/auth/ForgotPasswordPage';
import OrdersPage from './components/orders/OrdersPage';
import OrderDetailPage from './components/orders/OrderDetailPage';
import firebase from './services/firebase';
import { session } from './services/session';
import Header from './components/Header';
import Raven from './services/raven';
import ScrollToTop from './components/ScrollToTop';

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    Raven.setUserContext({
      email: user.email,
      id: user.uid
    });
    session.set('uid', user.uid);
  } else {
    Raven.setUserContext();
    session.flush();
  }
});

class App extends Component {
  render() {
    return (
      <Router>
        <ScrollToTop>
          <div className="container pt-3 pb-3">
            <Header />
            <Switch>
              <Route exact path={routes.LOGIN} component={LoginPage} />
              <Route
                exact
                path={routes.FORGOT_PASSWORD}
                component={ForgotPasswordPage}
              />
              <ProtectedRoute
                exact
                path={routes.ORDER_DETAIL}
                component={OrderDetailPage}
              />
              <ProtectedRoute
                exact
                path={routes.ORDERS}
                component={OrdersPage}
              />
              <Route render={() => <Redirect to={routes.ORDERS} />} />
            </Switch>
          </div>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js